module.exports = __webpack_public_path__ + "static/media/l_dot_13.754c9927.png";